<template>
  <TournamentScheduleForm />
</template>
  
<script>
  import TournamentScheduleForm from '@/components/tournament-schedule/TournamentScheduleForm.vue';
  
  export default {
    name: "TournamentScheduleCreatePage",
    components: {
      TournamentScheduleForm,
    },
  };
</script>
  